import { TextStyle as p } from "../../node_modules/@tiptap/extension-text-style/dist/index.mjs";
import { Plugin as k, PluginKey as u } from "../../node_modules/prosemirror-state/dist/index.mjs";
const g = new u("restoreMarks"), x = p.extend({
  addProseMirrorPlugins() {
    return [f()];
  }
}), f = () => new k({
  key: g,
  appendTransaction: (l, i, o) => {
    const c = l.some((e) => e.docChanged), a = !i.selection.eq(o.selection);
    if (!c && !a)
      return null;
    const { selection: d } = o, { $head: r } = d;
    if (r.parent.content.size === 0 || r.parent.content.size === 1 && r.parent.textContent === "") {
      let e = o.storedMarks || r.marks();
      if (!e || e.length === 0) {
        const t = r.before(r.depth) - 1;
        if (t > 0) {
          const s = o.doc.nodeAt(t);
          if (s && s.content.size > 0) {
            const n = t + s.content.size;
            e = o.doc.resolve(n).marks();
          }
        }
      }
      if (e && e.length > 0) {
        const t = [
          "bold",
          "italic",
          "strike",
          "underline",
          "textStyle",
          "textColor",
          "textBackgroundColor",
          "fontSize",
          "fontFamily"
        ], s = e.filter((n) => t.includes(n.type.name));
        if (s.length > 0) {
          const n = o.tr;
          return n.setStoredMarks(s), n;
        }
      } else {
        const t = o.tr;
        return t.setStoredMarks([]), t;
      }
    }
    return null;
  }
});
export {
  x as TextStyle
};
